import { Controller } from 'stimulus'
import '@stimulus/polyfills'

export default class extends Controller {
}
